import { getGDPRSettings } from '@dg-util'
import { AuthMethod } from '../../constants/auth-constants'
import { ContextType, EventType } from './config'

// v5 passes a single `{ context, event }` argument to guards instead of `(context, event)`.
type GuardArg = { context: ContextType; event: EventType }

const isAuthorized = ({ context }: GuardArg) => !!context.authorized
const gdpr_setting = getGDPRSettings()
const isGDPRAccept = () => gdpr_setting.cookies

const isVerify = ({ event }: GuardArg) => !!event.isVerify

const isVippsAuth = ({ context }: GuardArg) =>
  [AuthMethod.VIPPS].includes(context.authMethod as AuthMethod)
const isAuthAgent = ({ context }: GuardArg) =>
  [AuthMethod.AGENT].includes(context.authMethod as AuthMethod)
const isNotVippsAuth = ({ context }: GuardArg) =>
  ![AuthMethod.VIPPS].includes(context.authMethod as AuthMethod)
const isBankIdAuth = ({ context }: GuardArg) =>
  [AuthMethod.BANKID].includes(context.authMethod as AuthMethod)

export default {
  isAuthorized,
  isGDPRAccept,
  isVerify,
  isVippsAuth,
  isNotVippsAuth,
  isBankIdAuth,
  isAuthAgent,
}
